import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";
import { QualifiedRoboqlQuery } from "@/shared/domain/query";

interface ConvertNlpToRoboqlOptions {
  orgId?: string;
  prompt: string;
}

export function useConvertNlpToRoboql() {
  const { queryService } = useDomainServices();

  // "Nope, we're not related, we get that a lot though" - queryClient
  const queryClient = useQueryClient();

  return useMutation<QualifiedRoboqlQuery, Error, ConvertNlpToRoboqlOptions>({
    mutationFn: async ({
      prompt,
      orgId,
    }: ConvertNlpToRoboqlOptions): Promise<QualifiedRoboqlQuery> => {
      return queryService.convertNlpToRoboql(prompt, {
        orgId: orgId,
      });
    },

    onSuccess: (roboqlRequest: QualifiedRoboqlQuery) => {
      queryClient.setQueryData(["roboqlRequest", prompt], roboqlRequest);
    },
  });
}
